(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initFaqSection(root) {
    root.querySelectorAll('.faq-section details').forEach(function (details) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content || summary.dataset.faqInitialized) return;
      summary.dataset.faqInitialized = 'true';

      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (content.id) {
        summary.setAttribute('aria-controls', content.id);
      }

      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        if (details.open && !reducedMotion.matches && typeof content.animate === 'function') {
          content.animate(
            {
              opacity: [0, 1],
              transform: ['translateY(-0.6rem)', 'translateY(0)']
            },
            {
              duration: 180,
              easing: 'ease-out'
            }
          );
        }
      });
    });
  }

  initFaqSection(document);

  document.addEventListener('shopify:section:load', function (event) {
    initFaqSection(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target.closest('.faq-section')) return;
    var details = event.target.querySelector('details');
    if (details && !details.open) {
      details.open = true;
    }
  });
})();
